const passkey_sign_in = {
    setup_page: {
        title: '로그인을 더 간편하게',
        subtitle: '패스키 만들기',
        description: '기기 생체인증, YubiKey 같은 보안 키 또는 다른 사용 가능한 방법으로 패스키를 등록하세요.',
    },
    trigger_conditional_ui_failed: '패스키 자동 채우기를 트리거하지 못했습니다.',
};
export default Object.freeze(passkey_sign_in);
